import React from 'react';
import './Termos.css';

/**
 * Página de Termos de Serviço
 * Necessária para verificação OAuth2 do Google Workspace
 */
const Termos = () => {
  return (
    <div className="termos-container">
      <div className="termos-content">
        <h1>Termos de Serviço - NerdzPoker</h1>
        
        <section>
          <h2>1. Aceitação dos Termos</h2>
          <p>
            Ao acessar o NerdzPoker, você concorda em cumprir estes termos. Este é um sistema 
            privado destinado exclusivamente a um grupo de amigos.
          </p>
        </section>

        <section>
          <h2>2. Uso do Sistema</h2>
          <ul>
            <li>
              O sistema é uma ferramenta de apoio para organização de partidas de poker (housegame).
            </li>
            <li>
              É proibido o uso de automações (bots) ou qualquer tentativa de burlar a segurança 
              da plataforma.
            </li>
          </ul>
        </section>

        <section>
          <h2>3. Isenção de Responsabilidade</h2>
          <p>
            O NerdzPoker é fornecido "como está". Não nos responsabilizamos por perdas de conexão 
            ou erros de sistema durante as partidas.
          </p>
        </section>

        <section>
          <h2>4. Conduta</h2>
          <p>
            Reservamo-nos o direito de remover o acesso de qualquer usuário que apresente 
            comportamento inadequado ou ofensivo aos demais membros do grupo.
          </p>
        </section>
        
        <footer className="app-footer">
          <div className="footer-content">
            <p className="footer-signature">
              Produzido by <strong>Chicão</strong>
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Termos;
